const map = {
  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
};

export function mapFileType(type: string) {
  return map[type] || type;
}
